module.exports = __webpack_public_path__ + "static/img/scly8dda50c.png";